// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-summary h3 {
  margin: 30px auto 10px;
}
.contact-summary p {
  color: var(--ion-color-secondary-tint);
}

.contact-add item.sc-ion-label-md-h,
.contact-add .item .sc-ion-label-md-h {
  --color: initial;
  display: block;
  color: var(--color);
  font-family: var(--ion-font-family, inherit);
  font-size: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  height: 38px;
  line-height: 38px;
}

ion-item.selected {
  --background: var(--ion-color-lighter-light);
}`, "",{"version":3,"sources":["webpack://./src/app/components/wizard/wizard-select-contact/wizard-select-contact.component.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;AAAJ;AAGE;EACE,sCAAA;AADJ;;AAME;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,sBAAA;EACA,YAAA;EAEA,iBAAA;AAJJ;;AASA;EACC,4CAAA;AAND","sourcesContent":[".contact-summary {\r\n  h3 {\r\n    margin: 30px auto 10px;\r\n  }\r\n\r\n  p {\r\n    color: var(--ion-color-secondary-tint);\r\n  }\r\n}\r\n\r\n.contact-add {\r\n  item.sc-ion-label-md-h,\r\n  .item .sc-ion-label-md-h {\r\n    --color: initial;\r\n    display: block;\r\n    color: var(--color);\r\n    font-family: var(--ion-font-family, inherit);\r\n    font-size: inherit;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n    height: 38px;\r\n\r\n    line-height: 38px;\r\n  }\r\n}\r\n\r\n\r\nion-item.selected {\r\n\t--background: var(--ion-color-lighter-light);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
